enum ParamName {
  Slug = 'slug',
}

export default ParamName;
